module.exports = new __parcel__URL__("back-to-the-future-part-ii.ddc3b1ae.jpg").toString();